export const PromotionRewardTarget = {
  Bonus: 'Bonus',
  Cash: 'Cash',
  FreeSpins: 'FreeSpins',
  Coins: 'Coins',
  InstantWheel: 'InstantWheel',
  BettyPoints: 'BettyPoints',
};
